export default __webpack_public_path__ + "static/media/workstation.e039da96.jpg";